<template>
  <div class="content">
    <div class="section">
      <div class="row u-hide-desktop u-center">
        <site-logo></site-logo>
        <space></space>
      </div>
      <div class="row level-items">
        <div class="col-6">
          <h1 class="font-alt">Training Portal</h1>
          <h3 class="font-light">Login</h3>
        </div>
        <div class="u-hide-tablet-only u-hide-mobile col-6 level u-text-right">
          <div class="u-fill-width">
            <site-logo></site-logo>
          </div>
        </div>
      </div>
      <div class="divider u-no-margin"></div>
      <space class="large"></space>
      <div class="form-section">
        <!-- Email / ARN -->
        <div class="row level">
          <div class="offset-2 col-12 error" v-if="error.username">
            {{ error.username }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width">
              Email or ARN:
              <span class="required">&emsp;</span>
            </span>
          </div>
          <div class="col-10 level-item input-control">
            <input
              class="input-contains-icon"
              type="text"
              tabindex="1"
              placeholder="ernst.k.gann@email.com"
              v-bind:class="{ 'input-error': error.username }"
              v-model="username"
            />
            <span class="icon">
              <i class="fa fa-wrapper fa-user-astronaut"></i>
            </span>
          </div>
        </div>
        <!-- Password -->
        <div class="row level">
          <div class="offset-2 col-12 error" v-if="error.password">
            {{ error.password }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width">
              Password:
              <span class="required">&emsp;</span>
            </span>
          </div>
          <div class="col-10 level-item input-control">
            <input
              class="input-contains-icon"
              type="password"
              placeholder="********"
              tabindex="2"
              v-bind:class="{ 'input-error': error.password }"
              v-model="password"
              v-on:keyup.enter="login"
            />
            <span class="icon"><i class="fa fa-wrapper fa-key"></i></span>
          </div>
        </div>
        <!-- Action buttons -->
        <space></space>
        <div class="row">
          <div class="offset-2 col-5 u-pull-left">
            <router-link tabindex="4" :to="{ name: 'reset-password' }">
              Forgotten your login details?
            </router-link>
          </div>
          <div class="col-5 u-fill-width">
            <button
              class="btn-primary u-pull-right tas-level-mobile-button"
              tabindex="3"
              v-on:click="login"
              value="Login"
              type="submit"
            >
              <loading-spinner v-show="loading"></loading-spinner>
              <span class="icon">
                <i
                  v-show="!loading"
                  class="fa-wrapper fa fa-sign-in fa-flip-horizontal normal-icon"
                  aria-hiden="true"
                >
                </i>
              </span>
              Login
            </button>
          </div>
        </div>
      </div>
      <server-error v-bind:error="error.serverError"></server-error>
    </div>
  </div>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";
import SiteLogo from "@/components/SiteLogo";
import ServerError from "@/components/ServerError";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "login",
  components: {
    SiteLogo,
    ServerError,
    LoadingSpinner
  },
  data: function() {
    return {
      loading: false,
      username: "",
      password: ""
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  methods: {
    validate_form: function() {
      var valid = true;
      if (!this.username) {
        this.$set(this.error, "username", "You must enter your username.");
        valid = false;
      }
      if (!this.password) {
        this.$set(this.error, "password", "You must enter your password.");
        valid = false;
      }
      return valid;
    },
    login: function() {
      this.loading = true;
      // Form error handling
      if (this.validate_form() == false) {
        // Break if not valid
        this.loading = false;
        return;
      }
      // Try to login to the server
      this.$store
        .dispatch("auth/login", {
          username: this.username,
          password: this.password
        })
        .then(() => (this.loading = false));
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
  }
};
</script>
